module.exports = __webpack_public_path__ + "static/media/notification-appointments.c805fdea.svg";